<template>
  <div class="p-2">
      <div class="device-info vx-col w-full">
          <div class="shadow-drop d-theme-dark-bg cursor-pointer round p-2">
            <iconOnOff :width="22" :height="22" iconColor="#EA5455" class="align-middle" v-if="status"/>
            <iconOnOff :width="22" :height="22" iconColor="#28C76F" class="align-middle" v-else/>
          </div>
          <div class="device-text-container">
            <span class="main-info" v-if="status">{{messageTrue != undefined ? messageTrue :$t("Messages.On")}}</span>
            <span class="main-info" v-else>{{messageFalse != undefined ? messageFalse :$t("Messages.Off")}}</span>
            <span class="subtext-info block" v-if="device" :class="classDescription">{{$t("Messages.AssignTo") +': '+ device}}</span>
            <span class="subtext-info" v-if="name" :class="classDescription">{{name}}</span>

          </div>
      </div>
  </div>
</template>
<script>
import iconOnOff from '@/components/icons/iconOnOff'

export default {
  components: {
    iconOnOff
  },
  props: {
    status: Boolean,
    messageTrue: String,
    messageFalse: String,
    name: String,
    device: String,
    classDescription: {
      type: String,
      default: ''
    }
  }
}
</script>
